import React, { useEffect, useState } from 'react';
import NextPrevButtons from '../Shared/NextPrevButtons';
import { makeStyles, TextField } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { dataService } from '../../Services/data.service';
import { toast } from 'react-toastify';

export default function CertificateInfo(props) {

    const [number, setNumber] = useState(null)
    const [validUntill, setValidUntill] = useState(null)

    const classes = useStyles();

    const setNextStep = () => {
        validate()
    }

    useEffect(() => {

        dataService.getCertificatesBySupplierID(props.addPage.vendorID).then((certs) => {

            if (certs.Results.length > 0) {
                if (JSON.stringify(certs.Results[0].Number) !== JSON.stringify(number)) {
                    setNumber(certs.Results[0].Number)
                }
                if (JSON.stringify(certs.Results[0].MomentValidUntil) !== JSON.stringify(validUntill)) {
                    setValidUntill(certs.Results[0].MomentValidUntil)
                }
            }
        }
        ).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        console.log(props.chosenValue)
        if (props.chosenValue) {
            if (props.chosenValue.number) {
                if (JSON.stringify(number) !== JSON.stringify(props.chosenValue.number)) {
                    setNumber(props.chosenValue.number)
                }
            }

            if (props.chosenValue.validUntil) {
                if (JSON.stringify(validUntill) !== JSON.stringify(props.chosenValue.validUntil)) {
                    setValidUntill(props.chosenValue.validUntil)
                }
            }
        }

    }, [])

    const validate = () => {
        if ((number && validUntill) || (!number && !validUntill)) {
            props.setContent({ number: number, validUntil: validUntill });
            props.actions.SetProduct(0)
            props.SetNext();
        } else {
            if(!validUntill){
                toast.error("Choose a date", { position: toast.POSITION.TOP_CENTER })
            }
            else{
                toast.error("Choose a certificate number", { position: toast.POSITION.TOP_CENTER })
            }
        }
    }

    const onChangeText = (e) => {
        setNumber(e.target.value)
    }

    const handleDateChange = (event) => {
        setValidUntill(event)
    }

    return (
        <div className={classes.container}>
            <TextField id="outlined-search" label="" type="search" value={number} variant="outlined" placeholder={"Enter certificate number"} className={classes.uiTextField} size="small" onChange={(e) => onChangeText(e)} />
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Choose a date"
                    value={validUntill}
                    minDate={new Date()}
                    onChange={(e) => handleDateChange(e)}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    className={classes.datePicker}
                />
            </MuiPickersUtilsProvider>
            <NextPrevButtons hasPrevious={props.hasPrevious} hasNext={props.hasNext} SetPrevious={props.SetPrevious} SetNext={setNextStep}></NextPrevButtons>
        </div>
    )

}

const useStyles = makeStyles({

    datePicker: {
        width: "100%"
    },
    uiTextField: {
        width: "100%",
        backgroundColor: "white"
    },
    container: {
        marginTop: "30px",
    }
})